var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlParkingOutlined = function SvgHtlParkingOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Zm1 0a6 6 0 1 0 6-6 6.007 6.007 0 0 0-6 6Zm4 3.5v-7a.5.5 0 0 1 .5-.5c.121 0 .292-.013.49-.027.96-.069 2.41-.175 3.308.666a2.414 2.414 0 0 1 .7 1.864v.006a2.318 2.318 0 0 1-.835 1.837 4.182 4.182 0 0 1-2.6.735c-.207 0-.4-.009-.561-.021v2.44a.5.5 0 0 1-1 0H6Zm3.531-3.927a1.343 1.343 0 0 0 .47-1.079 1.448 1.448 0 0 0-.385-1.125c-.579-.542-1.767-.455-2.552-.4h-.062v3.084a3.869 3.869 0 0 0 2.529-.48Z"
  })));
};
export default SvgHtlParkingOutlined;